(() => {
  const initBuyBar = () => {
    const bar = document.querySelector('[data-assured-mobile-buybar]');
    const originalButton = document.querySelector('.product-form__submit');
    if (!bar || !originalButton || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    const mobileButton = bar.querySelector('[data-assured-mobile-add]');
    const mobilePrice = bar.querySelector('[data-assured-mobile-price]');
    const priceSource = document.querySelector('.product__info-container .price-item--regular');

    const sync = () => {
      if (priceSource && mobilePrice) mobilePrice.textContent = priceSource.textContent.trim();
      mobileButton.disabled = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
      mobileButton.textContent = originalButton.textContent.trim() || 'Add to cart';
    };

    mobileButton.addEventListener('click', () => {
      sync();
      if (!mobileButton.disabled) originalButton.click();
    });

    const buttonObserver = new MutationObserver(sync);
    buttonObserver.observe(originalButton, { attributes: true, childList: true, subtree: true });
    if (priceSource) buttonObserver.observe(priceSource, { childList: true, subtree: true });

    const updateVisibility = () => {
      const rect = originalButton.getBoundingClientRect();
      const show = rect.bottom < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    sync();
    updateVisibility();
  };

  const initVariantMenus = () => {
    document.querySelectorAll('[data-assured-variant-menu]:not([data-ready])').forEach((menu) => {
      menu.dataset.ready = 'true';
      const trigger = menu.querySelector('.assured-variant-menu__trigger');
      const list = menu.querySelector('.assured-variant-menu__list');
      const selectedLabel = menu.querySelector('[data-assured-variant-selected]');
      const nativeSelect = menu.parentElement.querySelector('.assured-native-variant-select');

      const close = () => {
        trigger.setAttribute('aria-expanded', 'false');
        list.hidden = true;
      };

      trigger.addEventListener('click', () => {
        const opening = list.hidden;
        document.querySelectorAll('[data-assured-variant-menu] .assured-variant-menu__list:not([hidden])').forEach((openList) => {
          openList.hidden = true;
          openList.parentElement.querySelector('.assured-variant-menu__trigger').setAttribute('aria-expanded', 'false');
        });
        list.hidden = !opening;
        trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });

      menu.querySelectorAll('[data-assured-variant-value]:not([disabled])').forEach((option) => {
        option.addEventListener('click', () => {
          nativeSelect.value = option.dataset.assuredVariantValue;
          selectedLabel.textContent = option.dataset.assuredVariantValue;
          menu.querySelectorAll('[role="option"]').forEach((item) => item.setAttribute('aria-selected', item === option ? 'true' : 'false'));
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          close();
        });
      });

      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) close();
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
    });
  };

  const enhanceReviews = () => {
    document.querySelectorAll('.jdgm-rev__body:not([data-assured-review])').forEach((body) => {
      body.dataset.assuredReview = 'true';
      if ((body.textContent || '').trim().length < 420) return;
      body.classList.add('assured-review-collapsed');
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'assured-review-toggle';
      toggle.textContent = 'Read more';
      toggle.addEventListener('click', () => {
        const expanded = body.classList.toggle('assured-review-expanded');
        body.classList.toggle('assured-review-collapsed', !expanded);
        toggle.textContent = expanded ? 'Show less' : 'Read more';
      });
      body.insertAdjacentElement('afterend', toggle);
    });
  };

  const init = () => {
    initBuyBar();
    initVariantMenus();
    enhanceReviews();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.setTimeout(() => {
        queued = false;
        initVariantMenus();
        enhanceReviews();
      }, 250);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
